export default {
	'report-dish-gross-profit': {
		id: 'report-dish-gross-profit',
		label: '菜品毛利分析表',
		code: '0008_0006'
	}
}
